import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadStepCompoundBuyCarConsent,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseConversationalLeadPage
      content={CarleadHIWWhyChooseWkdaFaq}
      manualForm={<CarleadStepCompoundBuyCarConsent showHeadline={false} />}
      showTrustPilot={true}
      howItWorksShowCta={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
